import { CONFIG } from "@rentiohq/shared-frontend/dist/config/app.config";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import {
  ERentioFormField,
  IUiSchema,
} from "@rentiohq/web-shared-next/dist/utils/types/form";
import { EField } from "./schema.addCustomMessage.types";

export const uiSchema = (): IUiSchema => {
  return {
    stepTitle: getLocalizedText("task.information.section_header"),
    heading: getLocalizedText("task.information.section_header"),
    fields: [
      {
        fieldKey: EField.CustomMessageBody,
        uiComponent: ERentioFormField.TextArea,
        title: getLocalizedText("share.document.custom_message.label"),
        required: true,
        componentProps: {
          autoFocus: true,
          multiline: true,
          minRows: 6,
          maxLength: () => CONFIG.CHAT_AND_EMAIL_TEXT_LIMIT,
        },
      },
    ],
  };
};
